<template>
  <div @touchstart.stop @touchend.stop @touchmove.stop>
    <div class="s_container" :class="[showPop ? 's_container_show' : '']" @click="clickClose">
      <div class="s_box s_box_black" @click.stop>
        <div class="s_box_hd">
          <div class="s_box_hd_tit" v-if="!isVip">
            <img src="@/static/images/playerDetail/coin_icon.png" />
            <div class="s_box_hd_tit_text">
              金币余额:
              <span class="s_box_hd_tit_num">{{
                userInfo && userInfo.all_coin ? userInfo.all_coin : 0
              }}</span>
            </div>
          </div>
          <div class="s_box_hd_tit_vip" v-else>
            <img src="@/static/images/playerDetail/vip_icon.png" />
            <span
              >有效期至:
              {{ userInfo && isVip ? formatDateDay(userInfo.vip_expire, true, true) : '-' }}</span
            >
          </div>
          <div class="s_box_close" @click="clickClose">
            <img src="@/static/images/playerDetail/icon-arrow.png" />
          </div>
        </div>
        <div v-if="showPop" class="s_box_bd">
          <div class="tab">
            <div
              :class="[tabsActive == index ? 'tab_item_active' : 'tab_item']"
              v-for="(item, index) in tabsList"
              :key="index"
              @click="tabchange(index)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="s_box_bd_content">
            <div
              class="content_item"
              :class="[
                videoAcitve == item.episode ? 'content_item_active' : '',
                !isVip && item.is_cost == 1 && !item.is_unlock ? 'content_item_lockbg' : ''
              ]"
              v-for="(item, index) in tabsList[tabsActive].list"
              :key="index"
              @click="clickItem(item, index)"
            >
              <img
                v-if="!isVip && item.is_cost == 1 && !item.is_unlock"
                class="content_item_lock"
                src="@/static/images/player/icon-lock.png"
              />
              <img
                v-if="item.is_cost == 1 && isVip"
                class="content_item_vip"
                src="@/static/images/player/tag-vip-r.png"
              />
              <div v-if="videoAcitve === item.episode" class="content_item_playing">
                <div class="content_item_playing_line_1 content_item_playing_line"></div>
                <div class="content_item_playing_line_2 content_item_playing_line"></div>
                <div class="content_item_playing_line_3 content_item_playing_line"></div>
              </div>
              <div class="content_item_tit numberItalic">{{ item.episode }}</div>
            </div>
          </div>
        </div>
        <div class="s_box_ft save_area">
          <div class="select_bottom_box" @click="goToSendMoney">
            <img
              class="select_bottom_bg"
              src="@/static/images/playerDetail/select_menu_bottom_bg.png"
            />
            <div class="select_bottom_left_text">
              <img
                class="select_bottom_left_text_top"
                src="@/static/images/playerDetail/player_recharge.png"
              />
              <span class="select_bottom_left_text_bottom"> 全部短剧均可使用 </span>
            </div>
            <div class="select_bottom_right_text">
              <img
                class="select_bottom_btn"
                src="@/static/images/playerDetail/select_menu_bottom_btn.png"
              />
              <span>立即充值</span>
            </div>
          </div>
          <div class="select_bottom_tip">
            注意：充值即代表同意
            <span style="color: #5589f3" @click="toAgreement">《充值协议》</span>
            ，未成年人需要在监护人指导、同意下进行相关操作
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import zyTabs from "@/components/zy-tabs/index.vue";
// import { getTemplate } from "@/api/pay.js";
// import { requestPayment } from "@/common/utils/requestPayment.js";
import { formatDateDay } from '@/common/utils'
import { localSet } from '@/common/storage'

export default {
  name: 'ZyPopVideoList',
  // components: { zyTabs },
  props: {
    videoDetail: {
      type: Object,
      default: null
    },
    isTabPage: {
      type: Boolean,
      default: true
    },
    episode: {
      type: Number,
      default: 0
    },
    videoList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showPop: false,
      showList: true,
      showColBtn: true,
      tabsList: [],
      tabsActive: 0,
      videoAcitve: 1,
      animationData: {},
      // isReuqestPay: false,
      vipObj: {},
      templateObj: {} // 充值模板对象
      // tabList: ['1-30', '31-60'],
      // activeTab: 0,
      // currentTab: 0
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'isVip',
      'mobileType',
      'miniappType',
      'videoVersionRecord',
      'currentPage'
    ])
  },
  watch: {
    showPop(newV) {
      if (newV) {
        // REPORT_SDK.report({
        //   event_name: "播放-剧目选集弹窗",
        //   event_id: "drama_pop_show",
        //   referer: this.currentPage,
        // });
      }
    }
  },
  created() {
    // this.getList();
    this.videoAcitve = this.episode
    this.sortArrs(this.videoList)
    const idx = this.videoList.findIndex((e) => e.episode == this.episode)
    if (idx >= 0) {
      this.tabsActive = Math.floor(idx / 30)
    }
    this.showPop = true
    // this.tabsActive = Math.floor(this.videoList.findIndex((e) => (e.episode == this.episode))+1 / 30)
    REPORT_SDK.report({
      event_id: 'drama_pop_show',
      event_name: '播放-剧目选集弹窗',
      referer: this.currentPage
    })
  },
  methods: {
    formatDateDay,
    // 跳转到充值协议
    toAgreement() {
      this.reportClick('充值协议')
      localSet({ name: 'jumpRecharge', value: true })
      this.$router.push('/Treaty')
    },
    async getList() {
      // 获取支付列表
      // getTemplate().then((res) => {
      //   console.log("[getTemplate]", res);
      //   const data = res.DATA.tpl;
      //   this.templateObj = data;
      //   this.vipObj = data.vip;
      // });
    },
    reportClick(e) {
      REPORT_SDK.report({
        event_name: '播放-剧目选集弹窗点击',
        event_id: 'drama_pop_click',
        referer: this.currentPage,
        element_name: e
      })
    },
    goToSendMoney() {
      this.reportClick('充值')
      this.$emit('openRechargePop')
    },
    clickItem(e) {
      this.reportClick(String(e.episode))
      if (e.is_cost == 1 && !e.is_unlock) {
        this.$store.commit('abPop/SET_RECHARGEPROPS', {
          // 充值浮层参数
          curCostCoins: e.coin,
          scene: '非剧集触发',
          from: 1 // 弹窗拉起来源 1-解锁视频  2-其他来源 3-福利中心
        })
        this.$emit('unlockVideo', {
          video_id: e.video_id,
          episode: e.episode,
          coin: e.coin
        })
        return
      }
      if (e.episode === this.videoAcitve) return
      this.videoAcitve = e.episode
      this.$emit('changeVideo', e)
      this.closeBox()
    },
    tabchange(e) {
      this.showList = false
      this.tabsActive = e
      setTimeout(() => {
        this.showList = true
      }, 40)
    },
    // computedAnimationDelay(index, nums) {
    //   const k = Math.floor(index / nums)
    //   return `${k * 80 + 80}ms`
    // },
    clickClose() {
      this.reportClick('关闭')
      this.closeBox()
    },
    closeBox() {
      if (!this.showPop) return
      this.showPop = false
      setTimeout(() => {
        this.$emit('closePop')
      }, 300)
    },

    sortArrs(arr) {
      if (arr.length <= 0) return
      const tabsLimit = 30
      if (arr.length === 1) {
        this.tabsList.push({
          name: `${arr[0].episode}`,
          list: arr
        })
        return
      }
      if (arr.length <= tabsLimit) {
        this.tabsList.push({
          name: `${arr[0].episode}-${arr[arr.length - 1].episode}`,
          list: arr.slice(0, tabsLimit)
        })
      } else {
        this.tabsList.push({
          name: `${arr[0].episode}-${arr[tabsLimit - 1].episode}`,
          list: arr.slice(0, tabsLimit)
        })
        this.sortArrs(arr.slice(tabsLimit, arr.length))
      }
    }
  }
}
</script>

<style lang="less" scoped>
.content_item_playing {
  position: absolute;
  top: 10px;
  left: 20px;
  width: 18px;
  height: 24px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  .content_item_playing_line {
    width: 4px;
    height: 14px;
    background: #ff4141;
    border-radius: 4px;
    animation-name: scaleAni;
    animation-iteration-count: infinite;
    animation-direction: alternate-reverse;
    transform-origin: bottom;
  }

  .content_item_playing_line_1 {
    animation-delay: 100ms;
    animation-duration: 470ms;
    height: 12px;
  }

  .content_item_playing_line_2 {
    animation-duration: 400ms;
  }

  .content_item_playing_line_3 {
    animation-duration: 380ms;
    height: 13px;
  }
}

.s_container {
  position: fixed;
  z-index: 10;
  height: 100%;
  width: 750px;
  bottom: 0;
  left: 0;
  transition: all 300ms;
  transform: translateY(100%);
  opacity: 0;

  .s_box {
    transition: all 300ms;
    background: rgba(0, 0, 0, 0.8);
    bottom: 0;
    left: 0;
    position: absolute;
    width: 750px;
    height: 900px;
    border-radius: 20px 20px 0 0;
    display: flex;
    flex-direction: column;
    padding-bottom: 30px;
    backdrop-filter: blur(10px);

    .s_box_hd {
      position: relative;
      height: 104px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      flex-shrink: 0;

      .s_box_hd_tit {
        display: flex;
        align-items: center;
        margin-left: 30px;

        img {
          width: 36px;
          height: 36px;
          margin-right: 6px;
        }

        .s_box_hd_tit_text {
          color: #fff;
          font-size: 28px;
          font-weight: normal;
          font-weight: 400;
        }

        .s_box_hd_tit_num {
          font-weight: 600;
        }
      }

      .s_box_hd_tit_vip {
        display: flex;
        align-items: center;
        margin-left: 30px;

        img {
          width: 91px;
          height: 31px;
          margin-right: 8px;
        }

        span {
          color: #fff;
          font-size: 28px;
          font-weight: normal;
          font-weight: 400;
        }
      }

      .s_box_close {
        position: absolute;
        right: 0;
        top: 0;
        width: 104px;
        height: 104px;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: rotate(180deg);
        img {
          width: 40px;
          height: 40px;
        }
      }
    }

    .s_box_bd {
      box-sizing: border-box;
      padding: 30px 10px 30px 30px;
      flex: 1;

      .tab {
        display: flex;
        flex-wrap: nowrap;
        width: 100%;
        margin-bottom: 30px;
        overflow-x: scroll;
        .tab_item,
        .tab_item_active {
          // width: 114px;
          height: 56px;
          margin-right: 18px;
          color: #fff;
          font-size: 28px;
          font-weight: 700;
          line-height: 56px;
          text-align: center;
          padding: 0 30px;
          flex-shrink: 0;
        }

        .tab_item_active {
          background-color: rgba(255, 255, 255, 0.1);
          border-radius: 200px;
          color: #fe2b54;
        }
      }

      .tab_main {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        height: 498px;
        overflow-y: auto;

        .tab_main_item,
        .tab_main_item_active {
          width: 100px;
          height: 100px;
          border-radius: 16px;
          background-color: rgba(170, 170, 170, 0.4);
          color: #fff;
          font-size: 36px;
          font-weight: 400;
          margin: 0 18px 18px 0;
          line-height: 100px;
          text-align: center;
        }

        .tab_main_item_active {
          color: #fe2b54;
        }
      }

      .s_box_bd_tabs {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        position: relative;
      }

      .s_box_bd_content_box {
        margin-top: 30px;
        height: 100%;
      }

      .s_box_bd_content {
        height: 580px;
        width: 690px;
        flex: 1;
        overflow-y: scroll;
        box-sizing: border-box;
        padding-bottom: 100px;
        .content_item {
          width: 120px;
          height: 120px;
          margin-right: 22px;
          margin-bottom: 22px;
          border-radius: 16px;
          background: rgba(170, 170, 170, 0.4);
          text-align: center;
          line-height: 120px;
          font-size: 36px;
          position: relative;
          float: left;
          opacity: 0;
          animation: bottomIn 240ms;
          animation-fill-mode: forwards;
          transform: translateY(100%);

          .content_item_tit {
            transition: all 300ms;
            font-weight: 600;
            height: 120px;
            line-height: 120px;
            transition: all 300ms;
            color: #fff;
          }
        }
        .scrollv_block {
          width: 750px;
          height: 120px;
          float: left;
          transition: all 300ms;
        }

        .scrollv_block_on {
          transform: scaleY(0);
        }

        .content_item_active {
          .content_item_tit {
            color: #ff4141;
          }
        }

        .content_item_lockbg {
          background: rgba(170 170 170, 0.2);

          .content_item_tit {
            color: rgba(255, 255, 255, 0.2);
          }
        }

        .content_item_lock {
          position: absolute;
          right: 10px;
          top: 10px;
          height: 36px;
          width: 36px;
        }

        .content_item_vip {
          position: absolute;
          width: 56px;
          height: 32px;
          right: 0px;
          border-top-right-radius: 16px;
          top: 0px;
        }

        .content_item:nth-child(5n + 5) {
          margin-right: 0;
        }

        .content_item_active {
          .content_item_tit {
            color: #ff4141;
          }
        }
      }
    }

    .s_box_ft {
      position: absolute;
      bottom: 0;
      width: 750px;
      height: 222px;
      background: #202020;
    }
  }
  .s_box_black {
    background: rgba(0, 0, 0, 0.95);
  }
}
.select_bottom_box {
  position: relative;
  margin-top: 30px;
  margin-left: 30px;
  width: 690px;
  height: 128px;
  .select_bottom_bg {
    position: absolute;
    left: 0;
    width: 690px;
    height: 128px;
  }
  .select_bottom_left_text {
    position: relative;
    display: flex;
    flex-direction: column;
    padding-left: 132px;
    padding-top: 28px;
    .select_bottom_left_text_top {
      width: 160px;
      height: 32px;
    }
    .select_bottom_left_text_bottom {
      margin-top: 8px;
      font-size: 24px;
      color: #513114;
      text-align: left;
      opacity: 0.7;
    }
  }
  .select_bottom_right_text {
    position: absolute;
    width: 156px;
    height: 64px;
    top: 32px;
    right: 27px;
    display: flex;
    align-items: center;
    justify-content: center;
    .select_bottom_btn {
      position: absolute;
      width: 156px;
      height: 64px;
    }
    span {
      position: relative;
      font-size: 28px;
      font-weight: 700;
      color: #513114;
    }
  }
}
.select_bottom_tip {
  width: 100%;
  margin-top: 18px;
  justify-content: center;
  font-size: 18px;
  text-align: center;
  color: #ffffff;
}

.save_area {
  padding-bottom: var(--safe-area-bottom);
}

.s_toast {
  border-radius: 16px;
  background: #000;
  justify-content: center;
  left: 184px;
  position: fixed;
  z-index: 99;
  bottom: var(--safe-area-bottom);
  width: 384px;
  height: 88px;
  display: flex;
  align-items: center;
  opacity: 0;
  transition: all 300ms;
  transform: translateY(192px);

  span {
    color: #fff;
    font-weight: 600;
    font-size: 28px;
  }

  .s_toast_line {
    height: 34px;
    width: 2px;
    background: #eee;
    margin: 0 20px;
  }
}
.toggleAni {
  opacity: 1;
  transform: translateY(-108px);
}
.s_container_show {
  opacity: 1;
  transform: translateY(0);
}

@keyframes scaleAni {
  from {
    transform: scaleY(0.3);
  }

  to {
    transform: scaleY(1);
  }
}

@keyframes bottomIn {
  from {
    opacity: 0;
    transform: translateY(100%);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fail_img {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #373737;
  border-radius: 16px;
}
</style>
